import { StyleSheet } from 'react-native';
import type { WcColors } from './matchPickStats.helper';

export const GRID_SIZE = 5;
export const CELL_SIZE = 32;
export const AXIS_W = 24;
export const FLAG_COL_W = 20;

export function getPickStatsScoreGridStyles(C: WcColors) {
  return StyleSheet.create({
    wrap: { padding: 10, paddingBottom: 12 },
    mainRow: {
      flexDirection: 'row',
      alignItems: 'stretch',
      justifyContent: 'center',
      alignSelf: 'center',
      marginLeft: -10,
    },
    yFlagCol: {
      width: FLAG_COL_W,
      alignItems: 'center',
      justifyContent: 'center',
      paddingBottom: 28,
    },
    grid: { gap: 3 },
    row: { flexDirection: 'row', gap: 3, alignItems: 'center' },
    axisLabel: {
      width: AXIS_W,
      fontSize: 10,
      color: C.inkMute,
      textAlign: 'center',
      fontWeight: '600',
    },
    cell: {
      width: CELL_SIZE,
      height: CELL_SIZE,
      borderRadius: 2,
      alignItems: 'center',
      justifyContent: 'center',
    },
    cellHot: { borderWidth: 1, borderColor: C.yellow },
    cellText: { fontSize: 8, fontWeight: '700', color: C.ink },
    xAxisRow: { flexDirection: 'row', gap: 3, marginTop: 3 },
    xAxisSpacer: { width: AXIS_W },
    xAxisLabel: {
      width: CELL_SIZE,
      fontSize: 10,
      color: C.inkMute,
      textAlign: 'center',
      fontWeight: '600',
    },
    xFlagRow: { flexDirection: 'row', marginTop: 4 },
    xFlagCenter: { flex: 1, alignItems: 'center' },
    internalHeader: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: 10,
      paddingHorizontal: 4,
    },
    internalTitle: { fontSize: 12, fontWeight: '800', color: C.ink },
    hotPickLabel: { fontSize: 10, color: C.inkDim, marginTop: 1 },
    hotPickValue: { color: C.yellow, fontWeight: '700' },
    legend: {
      marginTop: 10,
      paddingTop: 8,
      borderTopWidth: 1,
      borderTopColor: C.line,
      flexDirection: 'row',
      justifyContent: 'flex-end',
      gap: 16,
    },
    legendItem: { flexDirection: 'row', alignItems: 'center', gap: 6 },
    legendDot: { width: 10, height: 10, borderRadius: 3 },
    legendDotHot: { backgroundColor: C.yellow },
    legendText: { fontSize: 10, color: C.inkDim },
  });
}
